import {
  type Dropdown,
  type OpportunitiesContractsListData,
  type PaginatedDropdownList,
  type ProductsListListData,
  type UsersListListData,
  productsListListInfiniteOptions,
  usersListListInfiniteOptions
} from '@crm/api'
import { RangePickerFilter } from '@crm/components'
import { InfiniteSelect } from '@crm/components'
import { useRolePermission } from '@crm/hooks/useRolePermission'
import { UserRoleCRM } from '@crm/types'
import {
  defaultFiltersMultipleValues,
  defaultFiltersNumberValues
} from '@crm/utils'
import { MoreFiltersPopover } from '@shared/components'
import { useQueryUpdate } from '@shared/hooks'
import { defaultFilters } from '@shared/utils'
import { useTranslation } from 'react-i18next'

export const ContractsFilter = () => {
  const { params, updateQuery } = useQueryUpdate()
  const { t } = useTranslation()

  const hasPermissionMix = useRolePermission([
    UserRoleCRM.manager,
    UserRoleCRM.admin
  ])

  const userValue = defaultFiltersMultipleValues(params?.owner)
  const productValue = defaultFiltersNumberValues(params?.product)

  const filtersCount = ['deadline_from', 'product'].filter(
    (filter) => params?.[filter]
  )?.length

  const onFilterChange = (
    filter: keyof NonNullable<OpportunitiesContractsListData['query']>,
    value: string[]
  ) => updateQuery({ [filter]: value, page: defaultFilters.page })

  const onResetMoreFilters = () =>
    updateQuery({
      deadline_from: undefined,
      deadline_to: undefined,
      product: undefined
    })

  return (
    <>
      {hasPermissionMix && (
        <InfiniteSelect<UsersListListData, PaginatedDropdownList, Dropdown>
          value={userValue}
          className="select-min-width"
          popupMatchSelectWidth
          placeholder={t('filter.lead_owner')}
          getQueryFunction={usersListListInfiniteOptions}
          onChange={(owner) => updateQuery({ owner })}
          baseOptions={{
            query: {
              preference: params?.owner
            }
          }}
        />
      )}

      <MoreFiltersPopover
        filterActiveCount={filtersCount}
        onResetMoreFilters={onResetMoreFilters}
      >
        <RangePickerFilter
          fromParam="deadline_from"
          toParam="deadline_to"
          placeholder={[t('deadline_from'), t('deadline_to')]}
        />

        <InfiniteSelect<ProductsListListData, PaginatedDropdownList, Dropdown>
          value={productValue}
          className="w-full"
          popupMatchSelectWidth
          placeholder={t('contracts.product')}
          getQueryFunction={productsListListInfiniteOptions}
          baseOptions={{
            query: {
              preference: params?.product
            }
          }}
          onChange={(product) => onFilterChange('product', product)}
        />
      </MoreFiltersPopover>
    </>
  )
}
